import { Outlet } from "react-router-dom";
import { AnnouncementBar } from "./AnnouncementBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileNav } from "./MobileNav";
import { CartDrawer } from "@/components/CartDrawer";
import { useEffect, useState } from "react";
import { StyleAdvisor } from "@/components/StyleAdvisor";

const LOCALES = [
  ["tr","TR · Türkçe"],["en","EN · English"],["de","DE · Deutsch"],["ar","AR · العربية"],
  ["fr","FR · Français"],["es","ES · Español"],["ru","RU · Русский"],["zh","ZH · 中文"],
];

export function Layout() {
  const [locale,setLocale]=useState(()=>localStorage.getItem("shule-locale")||"tr");
  useEffect(()=>{
    localStorage.setItem("shule-locale",locale);
    document.documentElement.lang=locale;
    document.documentElement.dir=locale==="ar"?"rtl":"ltr";
  },[locale]);
  return (
    <div className="min-h-screen flex flex-col">
      <AnnouncementBar />
      <div className="border-b border-shule-line bg-shule-paper">
        <div className="container-shule flex min-h-10 items-center justify-start">
          <label className="inline-flex items-center gap-2">
            <span className="text-[10px] uppercase tracking-[0.18em] text-shule-mocha/70">Dil</span>
            <select aria-label="Dil / Language" value={locale} onChange={e=>setLocale(e.target.value)}
              className="border-0 bg-transparent py-2 pr-7 text-xs font-semibold text-shule-mocha outline-none">
              {LOCALES.map(([value,label])=><option key={value} value={value}>{label}</option>)}
            </select>
          </label>
        </div>
      </div>
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <MobileNav />
      <CartDrawer />
      <StyleAdvisor />
    </div>
  );
}
